import * as yup from "yup";

export const GlobalVariablesSetupValidationSchema = yup.object().shape({
	taxYear: yup.string().required("Year is required"),
	province: yup.string().required("Province is required"),
	effectiveDate: yup.string().required("Effective Date is required"),
});
